<template>
  <div
    class="align-items-center d-flex flex-fill justify-content-center"
    :class="height"
  >
    <Spinner color="primary" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    height: {
      required: false,
      default: "vh-50",
    },
  },
});
</script>
